import Button from "components/BaseWidgets/button";
import React, { useEffect, useState } from "react";
import FooterButton from "../FooterButton";
import DetailsCards from "./components/DetailsCards";
import DeactivateModal from "./components/DeactivateModal";
import { useDeleteAccount, useUpdateCredentials } from "hooks/api/useSettings";
import Skeleton from "components/BaseWidgets/skeleton";
import { removeToken, retrieveToken } from "utils/storage";
import { useQueryClient } from "@tanstack/react-query";
import AlertNotification from "components/CustomWidgets/alertNotification";

function AccountSettings({ data, isLoading }) {
  const queryClient = useQueryClient();
  const [modal, setModal] = useState(false);
  const updatedMail = retrieveToken("updatedMail");
  const updatedMobile = retrieveToken("updatedMobile");
  const updatedCountryCode = retrieveToken("updatedCountryCode");
  const [isVerified, setIsVerified] = useState(false);
  const [update, setUpdate] = useState(null);
  const { mutate: updateCredentials, isLoading: updateLoading } =
    useUpdateCredentials({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["account_settings"] });

        if (update === "mail") {
          removeToken("updatedMail");
          return;
        }

        if (update === "mobile") {
          removeToken("updatedMobile");
          return;
        }
        removeToken("isVerifiedTemp");
      },
    });
  const { mutate: deleteAccount, isLoading: dltLoading } = useDeleteAccount({
    onSuccess: () => {},
  });

  useEffect(() => {
    const verified = retrieveToken("isVerifiedTemp");
    if (verified === "true") {
      setIsVerified(true);
    }
  }, []);

  return (
    <>
      <div className="tab-content">
        <h1 className="tab-title ">Account settings</h1>
        {isLoading ? (
          <Skeleton label={false} height={270} />
        ) : (
          <DetailsCards
            data={data?.settings_data}
            updateCredentials={updateCredentials}
            setIsVerified={setIsVerified}
            update={update}
            setUpdate={setUpdate}
          />
        )}
        <Button
          onClick={() => setModal(true)}
          variant="link"
          className="deactivate-btn"
        >
          Deactivate your account
        </Button>
        {/* NOTE : This is needed ,commented temporary <Save is disabled as phone number changes are handled via verification flow> */}
        {/* <FooterButton
          isLoading={updateLoading}
          onSave={() => {
            if (!isVerified) {
              AlertNotification(
                "warning",
                "Please verify your updated email or phone number before saving.",
              );
              return;
            }
            let countryId;
            if (updatedCountryCode) {
              countryId = updatedCountryCode;
            } else {
              const countryData = data?.country_codes?.find(
                (item) => item.code === data?.settings_data?.countrycode,
              );
              countryId = countryData?.id;
            }
            const payload = {
              email: updatedMail || data?.settings_data?.email,
              phone: updatedMobile || data?.settings_data?.phone,
              country_code: Number(updatedCountryCode),
            };

            updateCredentials(payload);
          }}
        /> */}
      </div>
      <DeactivateModal
        isLoading={dltLoading}
        open={modal}
        setOpen={setModal}
        onSubmit={(value) => {
          const payload = {
            reason: value,
            is_deactivate: true,
          };
          deleteAccount(payload);
        }}
      />
    </>
  );
}

export default AccountSettings;
